module.exports = "<div class=login-container layout=column layout-align=\"center center\"> <imomo-login-card></imomo-login-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/login/login.html
 ** module id = 332
 ** module chunks = 0
 **/